"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../../Text"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Price = _interopRequireDefault(require("../../Price"));
var _utilities = _interopRequireDefault(require("../../../utilities"));
var _PriceContext = require("@airasia/phoenix-common/common/PriceContext");
var _constant = require("../../JourneyPriceCTA/constant");
var _UpsellBanner = _interopRequireDefault(require("../../UpsellBanner"));
var _constant2 = require("../../UpsellBanner/constant");
var _constant3 = require("../constant");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var BaggageContainer = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__BaggageContainer",
  componentId: "sc-smmf6w-0"
})(["padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.small, " ").concat(theme.space.standard, " ").concat(theme.space.small);
});
var BaggageSegement = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__BaggageSegement",
  componentId: "sc-smmf6w-1"
})(["display:", ";grid-template-columns:", ";grid-row-gap:", ";grid-column-gap:", ";margin-top:", ";"], function (_ref2) {
  var optLen = _ref2.optLen,
    isMobile = _ref2.isMobile,
    baggageType = _ref2.baggageType;
  return optLen > 2 || isMobile && baggageType !== _constant3.BAGGAGE_TYPES.handCarry ? "grid" : "flex";
}, function (_ref3) {
  var theme = _ref3.theme,
    optLen = _ref3.optLen;
  return optLen > 4 ? "repeat(3, calc((100% - ".concat(theme.space.standard, ") / 3))") : "repeat(2, calc((100% - ".concat(theme.space.standard, ") / 2))");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.XSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.tiny;
});
var Title = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "SegementByWeight__Title",
  componentId: "sc-smmf6w-2"
})(["font-size:", ";line-height:", ";justify-content:center;display:flex;align-items:center;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeight.XLarge;
});
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__Wrapper",
  componentId: "sc-smmf6w-3"
})(["margin-right:", ";display:flex;flex:1;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.xxtiny;
});
var PriceContainer = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__PriceContainer",
  componentId: "sc-smmf6w-4"
})([""]);
var BaggageOption = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__BaggageOption",
  componentId: "sc-smmf6w-5"
})(["min-width:", ";padding:", ";border:", ";border-radius:", ";display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;box-sizing:border-box;", " ", ""], function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.space.semiXXLarge);
}, function (_ref11) {
  var theme = _ref11.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
}, function (_ref12) {
  var theme = _ref12.theme,
    borderColor = _ref12.borderColor;
  return "".concat(theme.space.mini, " solid ").concat(theme.colors[borderColor || 'greyLight']);
}, function (_ref13) {
  var theme = _ref13.theme,
    move = _ref13.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
}, function (_ref14) {
  var theme = _ref14.theme,
    isSelected = _ref14.isSelected;
  return isSelected && "\n    background-color: ".concat(theme.backgroundColor.secondaryLight, ";\n  ");
}, function (_ref15) {
  var theme = _ref15.theme,
    isSelectionUnAvailable = _ref15.isSelectionUnAvailable;
  return isSelectionUnAvailable && "\n    background-color: ".concat(theme.backgroundColor.primary, ";\n    p {\n      color: ").concat(theme.colors.greyLight, ";\n    }\n  ");
});
var IncludedOption = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__IncludedOption",
  componentId: "sc-smmf6w-6"
})(["min-width:", ";border:", ";border-radius:", ";flex:1;", ""], function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.space.semiXXLarge);
}, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.space.mini, " solid ").concat(theme.colors.lightGrey);
}, function (_ref18) {
  var theme = _ref18.theme,
    move = _ref18.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
}, function (_ref19) {
  var theme = _ref19.theme,
    isSelected = _ref19.isSelected;
  return isSelected && "background-color: ".concat(theme.backgroundColor.default, ";");
});
var TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__TitleWrapper",
  componentId: "sc-smmf6w-7"
})(["min-width:", ";padding:", ";"], function (_ref20) {
  var theme = _ref20.theme;
  return "".concat(theme.space.semiXXLarge);
}, function (_ref21) {
  var theme = _ref21.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
});
var IncludedWrapper = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__IncludedWrapper",
  componentId: "sc-smmf6w-8"
})(["padding:", ";background-color:", ";border-top:1px solid ", ";display:flex;flex-direction:row;justify-content:space-evenly;"], function (_ref22) {
  var theme = _ref22.theme;
  return "".concat(theme.space.nano, " ").concat(theme.space.micro);
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.tertiaryLight;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.default;
});
var SportsEquipmentLabel = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__SportsEquipmentLabel",
  componentId: "sc-smmf6w-9"
})(["display:flex;padding:", ";cursor:pointer;"], function (_ref25) {
  var theme = _ref25.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.small, " ").concat(theme.space.standard, " ").concat(theme.space.small);
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__IconWrapper",
  componentId: "sc-smmf6w-10"
})(["display:flex;align-items:center;justify-content:center;"]);
var IncludedWithPlusWrapper = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__IncludedWithPlusWrapper",
  componentId: "sc-smmf6w-11"
})(["display:flex;"]);
var BaggageUpsellBanner = _styledComponents.default.div.withConfig({
  displayName: "SegementByWeight__BaggageUpsellBanner",
  componentId: "sc-smmf6w-12"
})(["margin-top:", ";"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.space.small;
});
var renderPriceSlashData = function renderPriceSlashData(currency, slashedPrice, theme, conversionRates) {
  var convertedPrice = slashedPrice;
  if (conversionRates) {
    convertedPrice = _utilities.default.getConvertedCurrency(slashedPrice !== null && slashedPrice !== void 0 ? slashedPrice : 0, currency, conversionRates);
  }
  return /*#__PURE__*/_react.default.createElement(_Price.default, {
    amount: convertedPrice,
    currency: currency,
    decimalType: "FLOAT",
    color: "greyDark",
    customFontSize: "small",
    priceTemplate: "TEMPLATE3",
    allowLocaleFormat: true,
    defaultIDRLocale: false,
    noDecimalValues: false,
    theme: theme,
    strikethrough: true
  });
};
var SegmentByWeight = function SegmentByWeight(props) {
  var objIndex = props.objIndex,
    baggageList = props.baggageList,
    baggageType = props.baggageType,
    translation = props.translation,
    showSportsEquip = props.showSportsEquip,
    setShowSportsEquip = props.setShowSportsEquip,
    getPrice = props.getPrice,
    optionSelected = props.optionSelected,
    setOptionSelected = props.setOptionSelected,
    onBaggageSelection = props.onBaggageSelection,
    isMobile = props.isMobile,
    accessible = props.accessible,
    theme = props.theme,
    showUpsellBanner = props.showUpsellBanner,
    upsellBannerConfig = props.upsellBannerConfig,
    isOnePaxView = props.isOnePaxView,
    selectedBaggages = props.selectedBaggages,
    setNoneAsDefault = props.setNoneAsDefault;
  var _usePriceContext = (0, _PriceContext.usePriceContext)(),
    conversionRates = _usePriceContext.conversionRates;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isExtraHandCarrySelected = _React$useState2[0],
    setIsExtraHandCarrySelected = _React$useState2[1];
  var initialLoadRef = _react.default.useRef(true);
  var isOptionAlreadySelected = function isOptionAlreadySelected(currIndex) {
    var _optionSelected$bagga;
    return !!((_optionSelected$bagga = optionSelected[baggageType]) !== null && _optionSelected$bagga !== void 0 && _optionSelected$bagga.includes(currIndex));
  };
  var isSomeOptionAlreadySelected = function isSomeOptionAlreadySelected() {
    return optionSelected && optionSelected[baggageType] && optionSelected[baggageType].length > 0;
  };
  var selectOption = function selectOption(currIndex) {
    var includedOptions = optionSelected && optionSelected[baggageType] ? optionSelected[baggageType].filter(function (idx) {
      return idx === -1 ? false : baggageList[idx].isIncluded || baggageList[idx].withBundle;
    }) : [];
    var newOptionsArr = isOptionAlreadySelected(currIndex) ? (0, _toConsumableArray2.default)(includedOptions) : [].concat((0, _toConsumableArray2.default)(includedOptions), [currIndex]);
    initialLoadRef.current = false;
    setOptionSelected(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, (0, _defineProperty2.default)({}, baggageType, newOptionsArr));
    });
  };
  var isComplimentaryBaggagePresent = function isComplimentaryBaggagePresent() {
    return baggageList.reduce(function (acc, _ref27) {
      var isIncluded = _ref27.isIncluded,
        withBundle = _ref27.withBundle;
      return acc || isIncluded || withBundle;
    }, false);
  };
  var getTotalSelectedWithUser = function getTotalSelectedWithUser(selectedBaggageType, currIndex) {
    var paxSelected = [];
    var totalSelected = 0;
    selectedBaggages.forEach(function (baggages, index) {
      var selectedBaggage = baggages[selectedBaggageType];
      if (selectedBaggage && selectedBaggage.includes(currIndex)) {
        paxSelected.push(index);
        totalSelected += 1;
      }
    });
    return {
      paxSelected: paxSelected,
      totalSelected: totalSelected
    };
  };
  var checkBaggageAvailability = function checkBaggageAvailability(currIndex, availability, selectedBaggageType) {
    var paxIndex = objIndex && objIndex.length > 0 ? objIndex.split('.')[1] : null;
    if (!selectedBaggages || selectedBaggages.length === 0) return true;

    // Considered as available if the availibility is null or undefined
    if (availability === 'null' || typeof availability === 'undefined') return true;
    if (availability && !availability.checkRequired) return true;
    var _getTotalSelectedWith = getTotalSelectedWithUser(selectedBaggageType || baggageType, currIndex),
      totalSelected = _getTotalSelectedWith.totalSelected,
      paxSelected = _getTotalSelectedWith.paxSelected;
    if (totalSelected >= availability.count && !paxSelected.includes(parseInt(paxIndex, 10))) {
      return false;
    }
    return true;
  };
  var checkHasUnAvailabileBaggage = function checkHasUnAvailabileBaggage() {
    return baggageList.some(function (baggage, index) {
      return (baggage === null || baggage === void 0 ? void 0 : baggage.availability) && !checkBaggageAvailability(index, baggage.availability, baggage.baggageType);
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  _react.default.useEffect(function () {
    return onBaggageSelection(optionSelected);
  }, [optionSelected]);
  _react.default.useEffect(function () {
    if (setNoneAsDefault && !isSomeOptionAlreadySelected()) {
      selectOption(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setNoneAsDefault]);
  _react.default.useEffect(function () {
    if (showSportsEquip && baggageType === _constant3.BAGGAGE_TYPES.sportsEquip && !isOnePaxView) {
      setTimeout(function () {
        document.getElementById("".concat(baggageType, "-").concat(objIndex)).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 150);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSportsEquip]);
  _react.default.useEffect(function () {
    var _optionSelected$BAGGA;
    if (((_optionSelected$BAGGA = optionSelected[_constant3.BAGGAGE_TYPES.handCarry]) === null || _optionSelected$BAGGA === void 0 ? void 0 : _optionSelected$BAGGA.length) > 1) {
      setIsExtraHandCarrySelected(true);
    }
  }, [optionSelected]);
  var move = theme === _constant.THEMES.MOVE;
  var getIncludedOption = function getIncludedOption(title, currIndex, icon) {
    var titleAsString = title.map(function (_ref28) {
      var weight = _ref28.weight;
      return weight;
    }).join(' + ');
    var isSelected = isOptionAlreadySelected(currIndex);
    if (!isSelected) selectOption(currIndex);
    return /*#__PURE__*/_react.default.createElement(IncludedWithPlusWrapper, {
      key: "".concat(titleAsString, "_").concat(currIndex)
    }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(IncludedOption, {
      id: baggageType,
      isSelected: isSelected,
      move: move
    }, /*#__PURE__*/_react.default.createElement(TitleWrapper, null, /*#__PURE__*/_react.default.createElement(Title, {
      bold: true,
      color: _constant3.COLOR_TYPES.title,
      tag: _constant3.TAG.div
    }, titleAsString)), /*#__PURE__*/_react.default.createElement(IncludedWrapper, null, /*#__PURE__*/_react.default.createElement(Title, {
      bold: true,
      color: _constant3.COLOR_TYPES.included
    }, icon ? translation.bundle : translation.included), icon && /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: _constant3.COLOR.green,
      fontsize: _constant3.SIZE.normal,
      icon: icon,
      theme: theme
    }))))));
  };
  var getNoneOption = function getNoneOption() {
    var borderColor = isOptionAlreadySelected(-1) ? _constant3.COLOR_TYPES.selected : _constant3.COLOR_TYPES.notSelected;
    var isSelected = isOptionAlreadySelected(-1);
    return /*#__PURE__*/_react.default.createElement(BaggageOption, {
      onClick: function onClick() {
        return selectOption(-1);
      },
      borderColor: borderColor,
      isSelected: isSelected,
      id: baggageType,
      move: move
    }, /*#__PURE__*/_react.default.createElement(Title, {
      bold: true,
      color: _constant3.COLOR_TYPES.title
    }, translation.none));
  };
  var getBaggageOption = function getBaggageOption(title, amount, currency, isPreSelected, originalPrice, currIndex, isUnAvailable, availability) {
    var borderColor = isOptionAlreadySelected(currIndex) ? _constant3.COLOR_TYPES.selected : _constant3.COLOR_TYPES.notSelected;
    var isSelected = isOptionAlreadySelected(currIndex);
    var titleAsString = title.map(function (_ref29) {
      var weight = _ref29.weight;
      return weight;
    }).join(' + ');
    var slashedPrice = originalPrice === null || originalPrice === void 0 ? void 0 : originalPrice.slashedPrice;
    var discount = originalPrice === null || originalPrice === void 0 ? void 0 : originalPrice.discount;
    var isAvailable = checkBaggageAvailability(currIndex, availability);
    if (isPreSelected && !isSomeOptionAlreadySelected()) selectOption(currIndex);
    if (isUnAvailable) return null;
    return /*#__PURE__*/_react.default.createElement(BaggageOption, {
      onClick: function onClick() {
        return isAvailable && selectOption(currIndex);
      },
      borderColor: borderColor,
      key: "".concat(titleAsString, "_").concat(currIndex),
      id: baggageType,
      isSelected: isSelected,
      move: move,
      isSelectionUnAvailable: !isAvailable
    }, /*#__PURE__*/_react.default.createElement(Title, {
      bold: true,
      color: _constant3.COLOR_TYPES.title
    }, titleAsString), discount > 0 && slashedPrice > 0 && renderPriceSlashData(currency, slashedPrice, theme, conversionRates), isAvailable && /*#__PURE__*/_react.default.createElement(PriceContainer, null, getPrice(amount, currency)), !isAvailable && /*#__PURE__*/_react.default.createElement(_Text.default, null, translation.unavailable));
  };
  var getUpsellBanner = function getUpsellBanner(config) {
    if (!config) {
      return null;
    }
    var text = config.text,
      ctaText = config.ctaText;
    return /*#__PURE__*/_react.default.createElement(BaggageUpsellBanner, null, /*#__PURE__*/_react.default.createElement(_UpsellBanner.default, {
      accessible: accessible,
      message: {
        text: text,
        ctaText: ctaText
      },
      theme: theme,
      textType: "textSmall",
      textColor: "neutral",
      imageUrl: _constant2.UPSELL_BANNER_IMAGE_URL,
      type: _constant2.FASTPASS
    }));
  };
  var getSegment = function getSegment() {
    var sizeDesc = translation["".concat(baggageType, "SizeDesc")];
    var hasBaggageUnavailable = checkHasUnAvailabileBaggage();
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, sizeDesc && /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant3.TEXT_TYPE.MOBILE_DESC.type,
      color: _constant3.TEXT_TYPE.MOBILE_DESC.color
    }, sizeDesc), hasBaggageUnavailable && baggageType !== _constant3.BAGGAGE_TYPES.handCarry && /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant3.TEXT_TYPE.MOBILE_DESC.type,
      color: _constant3.TEXT_TYPE.MOBILE_DESC.color
    }, translation.baggageUnAvailableNotification), /*#__PURE__*/_react.default.createElement(BaggageSegement, {
      optLen: baggageList.length,
      isMobile: isMobile,
      baggageType: baggageType
    }, !isComplimentaryBaggagePresent() && getNoneOption(), baggageList.map(function (_ref30, currIndex) {
      var title = _ref30.title,
        currency = _ref30.currency,
        amount = _ref30.amount,
        isPreSelected = _ref30.isPreSelected,
        originalPrice = _ref30.originalPrice,
        isIncluded = _ref30.isIncluded,
        withBundle = _ref30.withBundle,
        icon = _ref30.icon,
        isUnavailable = _ref30.isUnavailable,
        availability = _ref30.availability;
      if (!(isIncluded || withBundle)) {
        return getBaggageOption(title, amount, currency, isPreSelected, originalPrice, currIndex, isUnavailable, availability);
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getIncludedOption(title, currIndex, icon), currIndex < baggageList.length - 1 && /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        color: _constant3.ICON_TYPES.plus.color,
        fontsize: _constant3.ICON_TYPES.plus.size,
        icon: _constant3.ICON_TYPES.plus.icon
      })));
    })), showUpsellBanner && baggageType === _constant3.BAGGAGE_TYPES.handCarry && isExtraHandCarrySelected && getUpsellBanner(upsellBannerConfig));
  };
  var getSportsEquipLabel = function getSportsEquipLabel() {
    return /*#__PURE__*/_react.default.createElement(SportsEquipmentLabel, {
      onClick: function onClick() {
        return setShowSportsEquip(true);
      }
    }, /*#__PURE__*/_react.default.createElement(Title, {
      bold: true,
      color: _constant3.COLOR_TYPES.sportsEquipmentLabel
    }, translation.sportsEquipmentLabel));
  };
  var getMain = function getMain() {
    return baggageType !== _constant3.BAGGAGE_TYPES.sportsEquip || showSportsEquip ? /*#__PURE__*/_react.default.createElement(BaggageContainer, {
      key: baggageType
    }, getSegment()) : getSportsEquipLabel();
  };
  return getMain();
};
var _default = SegmentByWeight;
exports.default = _default;